import { newHopeAudienceEmail } from '../../../common/constants';

const DEFAULT_STATE: IBrandOnboardFooterState = {
	viewText: 'Beacon Hub FAQs –Learn how to use the Beacon Hub to edit your brand’s data',
	onboardingGuideText: 'here.',
	orText: 'or',
	videoTutorialText: 'video tutorials.',
	learnMoreAboutText: 'Learn more about',
	newHopeStandardsText: 'New Hope Network’s Standards',
	reachOutText: 'Reach out to our Audience Success Team at',
	audienceText: newHopeAudienceEmail,
	onboardingConcernText: 'with any onboarding questions or concerns.',
	onboardingGuideLink: '/beaconFAQ',
	videoTutorialLink: 'https://standards.newhope.com/onboarding/?playlist=0e0863e&video=49ea44c',
	newHopeNetworkLink: 'https://standards.newhope.com/',
	audienceLink: newHopeAudienceEmail,
	footerTitle: 'We’re Here To Help!',
	viewOnBoardingText: 'View our onboarding guide',
	viewOnBoardingLink:
		'https://standards.newhope.com/wp-content/uploads/2024/09/NHN_Guide_Updated_SEPT_2024-4.pdf',
	viewOnBoardingLinkText: 'here.'
};

interface IBrandOnboardFooterState {
	viewText: string;
	onboardingGuideText: string;
	orText: string;
	videoTutorialText: string;
	learnMoreAboutText: string;
	newHopeStandardsText: string;
	reachOutText: string;
	audienceText: string;
	onboardingConcernText: string;
	footerTitle: string;
	onboardingGuideLink: string;
	videoTutorialLink: string;
	newHopeNetworkLink: string;
	audienceLink: string;
	viewOnBoardingText: string;
	viewOnBoardingLink: string;
	viewOnBoardingLinkText: string;
}

export const BrandOnboardFooterModel = {
	...DEFAULT_STATE
};
